module.exports = __webpack_public_path__ + "media/music7.052e1ccf.mp3";